App.namespace('track', () => {
  const sent = {};

  const getPageContext = (pathname = '') => {
    const parts = pathname.split('/');
    parts.shift(); // remove first empty string

    // if first segment is two characters long assume it's country code and ignore
    if (parts[0] && parts[0].length === 2) {
      return parts[1] || 'home';
    }

    return parts[0] || 'home';
  };

  const mapPayloadItem = item => {
    let device = 'desktop';
    if (window.matchMedia('(max-width: 768px)').matches) {
      device = 'mobile';
    } else if (window.matchMedia('(max-width: 1280px)').matches) {
      device = 'tablet';
    }

    // device information
    item._host = window.location.host;
    item._pathname = window.location.pathname;
    item._href = window.location.href;
    item._userAgent = window.navigator.userAgent;
    item._device = device;
    item._context = getPageContext(window.location.pathname);
    item._userType = window.__TGV_USER_DATA ? window.__TGV_USER_DATA.type : null;

    if (item.meta && typeof item.meta !== 'string') {
      console.log('Got: ', item.meta);
      throw new Error('Tracking meta must be a string!');
    }

    return item;
  };

  const generatedRequestKey = (url, jsonData) => {
    return `${url}_${jsonData}`;
  };

  const ajax = (url, data, options = {}) => {
    if (!url) {
      console.error(`Not data endpoint defined, got: ${url}`);
      Rollbar.error('Not data endpoint defined', { url });
      return;
    }

    const jsonData = JSON.stringify(data);

    if (options.once && sent[generatedRequestKey(url, jsonData)]) {
      return;
    }

    sent[generatedRequestKey(url, jsonData)] = true;

    if (App.debug) {
      let value = data.value;
      // try parsing value as JSON for better output
      try {
        value = JSON.parse(data.value);
      } catch (err) {}

      console.log(`Tracking endpoint: ${url} with options: ${JSON.stringify(options)}`);
      console.log('Data:', data);
      console.log('Value:', value);
    }

    if (window.navigator.sendBeacon) {
      try {
        window.navigator.sendBeacon(url, jsonData);
        return;
      } catch (err) {
        // ignore
      }
    }

    $.ajax({
      url,
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      data: jsonData,
    });
  };

  const error = (payload = {}) => {
    ajax(window.__DATA_TRACKING_ENDPOINT_ERROR, mapPayloadItem(payload));
  };

  const performance = (payload = {}) => {
    ajax(window.__DATA_TRACKING_ENDPOINT_PERF, mapPayloadItem(payload));
  };

  const custom = (endpoint, payload = {}, options = {}) => {
    ajax(endpoint, mapPayloadItem(payload), options);
  };

  /**
   * Track to Google Analytics and ES
   * @param payload
   * @param options
   */
  const all = (payload = {}, options = {}) => {
    options.sendToAnalytics = true;
    ajax(window.__DATA_TRACKING_CUSTOM_EVENTS, mapPayloadItem(payload), options);
  };


  /**
   * Track to custom index ES
   * @param payload
   * @param options
   */
  const es = (payload = {}, options = {}) => {
    ajax(window.__DATA_TRACKING_CUSTOM_EVENTS, mapPayloadItem(payload), options);
  };

  const customAsync = (endpoint, payload = {}) => {
    setTimeout(() => custom(endpoint, payload));
  };

  const roomCardCarouselPayloadValid = (payload) => {
    const {
      roomId, context, tagSlug, position, page,
      photoIndex, photoUrl, totalPhotos,
    } = payload;

    return roomId && context && photoUrl
      && typeof tagSlug !== 'undefined'
      && $.isNumeric(totalPhotos)
      && $.isNumeric(position)
      && $.isNumeric(photoIndex)
      && $.isNumeric(page);
  };

  const roomCardClick = (payload) => {
    const {
      roomId, context, tagSlug, position, page,
      photoIndex, photoUrl, totalPhotos,
    } = payload;

    if (!roomCardCarouselPayloadValid(payload)) {
      return;
    }

    const landingLocationPage = Number(App.es6.shared.cookie.get('tgv_landing_location_page')) || null;

    App.track.custom(window.__DATA_TRACKING_ENDPOINT_ROOMS, {
      event: 'room_click',
      roomId,
      context,
      tagSlug,
      position,
      page,
      photoIndex,
      photoUrl,
      totalPhotos,
      landingLocationPage,
    });
  };

  const roomCardCarouselArrowClick = (payload) => {
    const {
      roomId, context, tagSlug, position, page,
      photoIndex, photoUrl, totalPhotos, arrowDirection, photoUrlAfter,
    } = payload;

    if (!roomCardCarouselPayloadValid(payload) || !arrowDirection || !photoUrlAfter) {
      console.error('Tracking: invalid carousel arrow tracking payload', payload);
      throw new Error('Tracking: invalid carousel arrow tracking payload');
    }

    App.track.custom(window.__DATA_TRACKING_ENDPOINT_ROOMS, {
      event: 'carousel_click',
      roomId,
      context,
      tagSlug,
      position,
      page,
      photoIndex,
      photoUrl,
      totalPhotos,
      arrowDirection,
      photoUrlAfter,
    });
  };

  const getUserId = function(user){
    if (!user) {
      return null;
    }
    if (user.type === "manager") {
      return `m${user.id}`;
    }
    if (user.type === "user") {
      return `c${user.id}`;
    }
    return null;
  };

  const getUserIdProperty = function(managerId, userId) {
    if (managerId) {
      return `m${managerId}`;
    }
    if (userId) {
      return `c${userId}`;
    }
    return null;
  }

  const checkDataKeys = (name, data) => {
    const ALLOWED_PARAMS = [
      'user_id',
      'tagvenue_user_id', 'tagvenue_manager_id', 'dms_user_id',

      'experiment_id', 'variant_id',
      'city', 'country', 'number_of_reviews_displayed', 'photos_count', 'rating', 'reviews_count' ,
      'position',
      'location_name', 'event_tag_slug', 'location_page_level', 'location_page_type',
      'number_of_people', 'event_date', 'rfp_state_label',
      'venue_id', 'room_id', 'rfp_id', 'booking_request_id', 'custom_offer_id', 'enquiry_id',
      'hour_from', 'hour_to', 'online_payments', 'company_id',
      'results', 'validation_error',
      'map_coordinates', 'map_zoom_level', 'price_max', 'price_min',

      'context', 'section', 'element', 'element_value', 'interaction',

      'exp_response_time', 'exp_response_rate', 'exp_online_status',
      'enquiry_form_variant', 'auth_method',
      'eventCallback', 'eventTimeout',
      'value', 'currency',

      'event_dates', 'event_hours_from', 'event_hours_to',

      'exp_pricing_update', 'exp_pricing_update_value', 'exp_pricing_confirmation', 'exp_pricing_confirmation_value',
      'exp_space_venue_type_id', 'exp_space_venue_type_label', 'exp_area_type_label', 'exp_area_type_slug',

      'enquiry_status',
    ];
    const wrongKeys = Object.keys(data).filter((key) => {
      return !ALLOWED_PARAMS.includes(key);
    });

    if (wrongKeys.length) {
      window.Rollbar.error(`TrackEvent: ${name} event has unsupported properties keys.`, { wrongKeys, data });
    }
  }

  const pushToLayerOnLoad = (data) => {
    if (document.readyState === 'complete') {
      window.dataLayer.push(data);
      return;
    }

    window.addEventListener('load', () => {
      window.dataLayer.push(data);
    });
  }

  const event = (eventName, eventData = {}) => {
    checkDataKeys(eventName, eventData);

    if (eventName === 'experiment_impression' ) {
      console.info(`AB: ${eventData.experiment_id} - ${eventData.variant_id}`);
    }

    App.es6.shared.user_data.getUser().then(user => {
      const userId = getUserId(user);

      const userData = {};
      if (userId) {
        userData.user_id = userId;
      }
      if (user) {
        if (user.type === "manager") {
          userData.tagvenue_manager_id = user.id; // to be removed in the future
        }
        if (user.type === "user") {
          userData.tagvenue_user_id = user.id; // to be removed in the future
        }
        if (user.dmsUserId) {
          userData.dms_user_id = user.dmsUserId;
        }
      }

      var data = {
        event: eventName,
        ...userData,
        ...window.__TGV_GA4_TRACKING,
        ...eventData,
      };

      data = clearNullValues(data);

      pushToLayerOnLoad(data);
    });
  };

  const clearNullValues = (data) => {
    for (const key in data) {
      if (data[key] === null) {
        delete data[key];
      }
    }
    return data;
  }

  const pageViewEvent = (eventData) => {
    event('page_view', eventData);
  }

  return {
    error,
    all,
    es,
    performance,
    custom,
    customAsync,
    getPageContext,
    roomCardClick,
    roomCardCarouselArrowClick,

    getUserIdProperty,
    event,
    pageViewEvent,
  };
});

